import React, { Component } from 'react';
import { Button, Container, CircularProgress, Grid, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { forgotPassword } from '../../../redux/actions/authActions';
import { setAlert } from '../../../redux/actions/alertActions';

// Constants
import { DEFAULT, GREY } from '../../../constants';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      notConfirmedError: false,
      alertText: '',
      submitted: false
    };
  }

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { email } = this.state;

    if (email === '') this.props.setError('Email cannot be empty.');
    else {
      this.props.handleForgotPassword(email);
      this.setState({ submitted: true });
    }
  };

  render() {
    return (
      <Container style={{ marginTop: '10%' }}>
        <h1
          style={{ color: GREY.dark, textAlign: 'center', marginTop: '1em', marginBottom: '1em' }}
        >
          Forgot Password
        </h1>

        {this.state.submitted ? (
          <Container style={{ textAlign: 'center' }}>
            <p>
              If that email is registered, a password reset link has been sent to it. The link will expire in 30 minutes.
            </p>
          </Container>
        ) : (
          <form autoComplete='off' onSubmit={this.onSubmit}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                {/* Email Field */}
                <TextField
                  fullWidth
                  type='email'
                  id='email'
                  label='Email'
                  value={this.state.email}
                  onChange={this.onChange}
                  variant='outlined'
                  required
                />
              </Grid>

              {/* Submit Button */}
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant='contained'
                  style={{ textTransform: 'none', backgroundColor: this.props.statusColor.main, color: this.props.statusColor.text }}
                  disabled={this.props.isLoading}
                  type='submit'>
                  Submit
                  {this.props.isLoading && <CircularProgress size={25} style={{ color: this.props.statusColor.text, marginLeft: '1em' }} />}
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  statusColor: state.status.schoolStatus ? state.status.schoolStatus.getColor() : DEFAULT,
  isLoading: state.auth.isLoading
});

const mapDispatchToProps = (dispatch) => ({
  setError: (msg) => setAlert(dispatch, msg),
  handleForgotPassword: (email) => forgotPassword(dispatch, email)
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);

ForgotPassword.propTypes = {
  setError: PropTypes.func,
  handleForgotPassword: PropTypes.func,
  statusColor: PropTypes.object,
  isLoading: PropTypes.bool
};
